import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { useOnMount } from '@wix/rules-panel-ui';
import { useAtomValue } from 'jotai';
import React from 'react';
import { WelcomeScreenClassicEditor } from '../../../assets/illustrations/welcome-screen-classic-editor';
import { isUnsupportedPageAtom } from '../../../atoms/session-atoms';
import { useA11yWizardAdapter } from '../../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../../hooks/use-bi-logger';
import { useMultilingualWarning } from '../../../hooks/use-multilingual-warning';
import { MissingSavePermissionWarning } from '../../../warnings/missing-save-permission-warning';
import { SecondaryBranchWarning } from '../../../warnings/secondary-branch-error';
import { SecondaryLanguageWarning } from '../../../warnings/secondary-language-error';
import { UnsupportedItemTypeSectionHelper } from '../../wizard-footer/unsupported-item-type-section-helper';
export const WizardPanelContentWelcome = _ref => {
  let {
    hasSavePermission,
    isPublishedBranch
  } = _ref;
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    capabilities
  } = useA11yWizardAdapter();
  const compactPanelChrome = capabilities.compactPanelChrome;
  const usesClassicModalChrome = capabilities.usesClassicModalChrome;
  const {
    shouldShowSecondaryLanguageWarning
  } = useMultilingualWarning();
  const isUnsupportedPage = useAtomValue(isUnsupportedPageAtom);
  const shouldShowSectionHelper = compactPanelChrome && isUnsupportedPage;
  const shouldShowWelcomeScreenIllustration = usesClassicModalChrome;
  const contentPadding = usesClassicModalChrome ? 'SP2 SP3 SP4 SP3' : compactPanelChrome ? 'SP2 SP8 SP4 SP8' : 'SP2 SP4 SP4 SP4';
  useOnMount(() => biLogger.panelView({}));
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    boxSizing: "border-box",
    direction: "vertical",
    gap: "SP1",
    height: "100%",
    padding: contentPadding
  }, !hasSavePermission && /*#__PURE__*/React.createElement(Box, {
    align: "center",
    margin: "SP2 0 28px 0"
  }, /*#__PURE__*/React.createElement(MissingSavePermissionWarning, null)), !isPublishedBranch && /*#__PURE__*/React.createElement(Box, {
    align: "center",
    margin: "SP2 0 28px 0"
  }, /*#__PURE__*/React.createElement(SecondaryBranchWarning, null)), shouldShowSecondaryLanguageWarning && /*#__PURE__*/React.createElement(Box, {
    align: "center",
    margin: "SP2 0 28px 0"
  }, /*#__PURE__*/React.createElement(SecondaryLanguageWarning, null)), shouldShowWelcomeScreenIllustration && /*#__PURE__*/React.createElement(Box, {
    align: "center",
    boxSizing: "border-box",
    direction: "vertical",
    paddingBottom: "SP2",
    paddingTop: shouldShowSecondaryLanguageWarning ? '0' : '76px'
  }, /*#__PURE__*/React.createElement(WelcomeScreenClassicEditor, null)), shouldShowSectionHelper && /*#__PURE__*/React.createElement(UnsupportedItemTypeSectionHelper, null), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "4px",
    paddingTop: shouldShowSecondaryLanguageWarning || shouldShowWelcomeScreenIllustration ? '0' : '64px',
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "bold"
  }, usesClassicModalChrome ? t('accessibility-wizard.welcome-screen.title.classic-editor') : t('accessibility-wizard.welcome-screen.title')), /*#__PURE__*/React.createElement(Text, {
    secondary: compactPanelChrome,
    size: "small",
    weight: "thin"
  }, usesClassicModalChrome ? t('accessibility-wizard.welcome-screen.description.classic-editor') : t('accessibility-wizard.welcome-screen.description'))));
};
//# sourceMappingURL=wizard-panel-content-welcome.js.map